/**
 * @packageDocumentation
 * @module f1/to
 */

export interface ToInteger {
  /**
   * Convert any value to an integer
   *
   * @public
   * @function f1.to.integer
   * @param value any value
   * @example
   *
   * ```ts
   * f1.to.integer('1') === 1
   * f1.to.integer('1xx') === 1
   * f1.to.integer('a1') === NaN
   * f1.to.integer(1) === 1
   * ```
   */
  (value: unknown): number;
}

/**
 * @see ToInteger
 */
export default (value: unknown): number => {
  return value === true ? 1 : value === false ? 0 : parseInt(`${value}`, 10);
};
